import { render, staticRenderFns } from "./PageBuilderSidebarContent.vue?vue&type=template&id=f8c5b038"
import script from "./PageBuilderSidebarContent.vue?vue&type=script&lang=js"
export * from "./PageBuilderSidebarContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports